import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

/* data imports */
import storyImagesObj from "../game-data/storyImagesObj";
import {
  dialogueSequenceEndHealthy,
  dialogueSequenceEndUnHealthy,
} from "../game-data/picnicStoryData";

/* comp imports */
import TypingText from "./TypingText";

/* animation imports */
import {
  elementsEntryExit,
  characterInactive,
} from "../../assets/js/animations";

const PicnicStoryWrapperEnd = ({
  dishFlag,
  setShowStoryEnd,
  gameResetHandler,
  handleRedirect,
}) => {
  const [step, setStep] = useState(0);
  const [dialogueSequence, setDialogueSequence] = useState([]);
  const [currentStepData, setCurrentStepData] = useState({});
  const [showNext, setShowNext] = useState(false);

  useEffect(() => {
    if (dishFlag !== "") {
      if (dishFlag === "green") {
        setDialogueSequence(dialogueSequenceEndHealthy);
      } else if (dishFlag === "red") {
        setDialogueSequence(dialogueSequenceEndUnHealthy);
      } else {
        setDialogueSequence([]);
      }
    }
  }, [dishFlag]);

  useEffect(() => {
    if (dialogueSequence.length > 0) {
      setCurrentStepData(dialogueSequence[step]);
    }
  }, [dialogueSequence, step]);

  const handleNext = () => {
    if (step < dialogueSequence.length - 1) {
      setStep(step + 1);
      setShowNext(false);
    } else {
      if (dishFlag === "green") {
        setShowStoryEnd(false);
        handleRedirect("/games");
      } else if (dishFlag === "red") {
        gameResetHandler();
        setShowStoryEnd(false);
      }
    }
  };

  return (
    <div className="story-convo-wrapper">
      <div
        className={`character-1-wrapper ${
          currentStepData.character === "carrot" ? "" : "low-brightness"
        }`}
      >
        <AnimatePresence>
          {currentStepData.imgLinkCarrot && (
            <motion.img
              src={
                currentStepData.imgLinkCarrot &&
                storyImagesObj[currentStepData.imgLinkCarrot]
              }
              alt="Carrot speaking"
              variants={
                currentStepData.character === "carrot"
                  ? elementsEntryExit
                  : characterInactive
              }
              initial="initial"
              animate="animate"
              exit="exit"
            />
          )}
        </AnimatePresence>
      </div>
      <div className="character-convo-wrapper text-center">
        <motion.div
          className={`talk-bubble ${
            currentStepData.character === "carrot"
              ? "tri-left"
              : currentStepData.character === "broccoli"
              ? "tri-right"
              : ""
          }`}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {currentStepData.character === "carrot" ? (
            <div className="story-character-name carrot-name">
              {currentStepData.character}
            </div>
          ) : currentStepData.character === "broccoli" ? (
            <div className="story-character-name broccoli-name">
              {currentStepData.character}
            </div>
          ) : null}
          <div className="talk-text">
            {Object.keys(currentStepData).length > 0 &&
              currentStepData.text && (
                <TypingText
                  key={step}
                  text={currentStepData.text}
                  speed={0.04}
                  onComplete={() => setShowNext(true)}
                />
              )}
            {showNext && (
              <button className="story-next-button" onClick={handleNext}>
                <span className="material-symbols-rounded">resume</span>
              </button>
            )}
          </div>
        </motion.div>
      </div>
      <div
        className={`character-2-wrapper ${
          currentStepData.character === "broccoli" ? "" : "low-brightness"
        }`}
      >
        <AnimatePresence>
          {currentStepData.imgLinkBroccoli && (
            <motion.img
              src={
                currentStepData.imgLinkBroccoli &&
                storyImagesObj[currentStepData.imgLinkBroccoli]
              }
              alt="Broccoli speaking"
              variants={
                currentStepData.character === "broccoli"
                  ? elementsEntryExit
                  : characterInactive
              }
              initial="initial"
              animate="animate"
              exit="exit"
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default PicnicStoryWrapperEnd;
